module.exports = __webpack_public_path__ + "img/IMG_2648.e0c2fb32.png";